export default class IncorrectPasswordError extends Error {
  email?: string;

  constructor(email?: string) {
    super(`Incorrect password for email: ${email}`);

    this.email = email;
  }
}
